// extracted by mini-css-extract-plugin
module.exports = {"CategoryesPage":"CategoriesPage_CategoryesPage__3ywXu","Category":"CategoriesPage_Category__1GvW5","NewCategory":"CategoriesPage_NewCategory__2Vz2k"};